import { Badge } from 'shared/components/ui/badge'
import { usePointDayWords, type PointDay } from './point-day-words'

/** A Point's day in one line: a badge when it is closed, and its hours today. */
export function PointDayMark({ day, testId }: { day: PointDay; testId?: string }) {
	const words = usePointDayWords()(day)
	if (!words.closure && !words.today) return null
	return (
		<span className='inline-flex flex-wrap items-center gap-1.5 text-sm' data-testid={testId}>
			{words.closure && (
				<Badge
					variant='outline'
					className='border-amber-500/60 text-amber-700 dark:text-amber-400'
					data-closure={day.closure}
				>
					{words.closure}
				</Badge>
			)}
			{words.today && <span className='text-muted-foreground'>{words.today}</span>}
		</span>
	)
}
